import { createAsyncThunk } from "@reduxjs/toolkit";
import managementSnApi from "../../../../configs/apis/management-sn";

export const validateSnRange = createAsyncThunk(
  "managementSn/validateSnRange",
  async (payload, { rejectWithValue }) =>
    managementSnApi
      .validateRange({
        fromSn: payload.fromSn,
        toSn: payload.toSn,
        inputType: payload.inputType,
      })
      .then((response) => response)
      .catch((error) => rejectWithValue(error))
);

export const moveSnToCompany = createAsyncThunk(
  "managementSn/moveSnToCompany",
  async (payload, { rejectWithValue }) =>
    managementSnApi
      .moveSn({
        companyId: payload.companyId,
        nodeId: payload.nodeId,
        fromSn: payload.fromSn,
        toSn: payload.toSn,
        inputType: payload.inputType,
      })
      .then((response) => response)
      .catch((error) => rejectWithValue(error))
);

export const getBranchList = createAsyncThunk(
  "managementSn/getBranchList",
  async (payload, { rejectWithValue }) =>
    managementSnApi
      .getBranchList({
        companyUuid: payload.companyUuid,
      })
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);
